import { ProductByHandleQuery } from "~lib/shopify/sdk";
import { withB2B } from "~lib/withB2B";

import { OptionSelector } from "./OptionSelector";
import { VariantSelection } from "./VariantSelection";

interface Props {
  story: any;
  product: ProductByHandleQuery["productByHandle"];
}

export const CustomerDivider = withB2B(({ product, story }: Props) => {
  return (
    <>
      <OptionSelector product={product} />
      <VariantSelection
        content={story?.content}
        isUpsellDisabled={story?.content.isUpsellDisabled}
        product={product}
        mb={["20px", "30px"]}
      />
    </>
  );
});
